import { TRuleWithTheme } from 'styles/theme';

export const container: TRuleWithTheme = ({ theme }) => ({
    marginTop: '25px',
});

export const row: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
});

export const card: TRuleWithTheme = ({ theme }) => ({
    marginBottom: '1.5rem',

    ':last-of-type': {
        marginBottom: 0,
    },
});

export const divider: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    height: 1,
    backgroundColor: theme.colors.dividerColor,
    margin: '1.25rem 0',
});
